import { render, staticRenderFns } from "./RetencionForm.vue?vue&type=template&id=f3e12a7c"
import script from "./RetencionForm.vue?vue&type=script&lang=js"
export * from "./RetencionForm.vue?vue&type=script&lang=js"
import style0 from "./RetencionForm.vue?vue&type=style&index=0&id=f3e12a7c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports